<script setup>
import { ref, onMounted, computed } from "vue";
import { storeToRefs } from "pinia";
import { useRouter, useRoute } from "vue-router";
import { useLangStore } from "@/stores/storeLang";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { usePrizeStore } from "@/stores/storePrize";

const storeScroll = useScrollStore();

const router = useRouter();
const route = useRoute();

const langStore = useLangStore();
const { t, lang } = storeToRefs(langStore);
const { setLang } = langStore;

const storeRequests = useRequestsStore();
const storePrize = usePrizeStore();

const nav = ref(null);

const isNotUserPage = computed(() => route.name === "not-user");

const tabs = [
	{ name: "profile", icon: "#profile" },
	{ name: "about", icon: "#promotion" },
	{ name: "prizes", icon: "#prize" },
	{ name: "faq", icon: "#faq" },
];

const toggleLang = async () => {
	const newLang = lang.value === "ru" ? "uz" : "ru";
	setLang(newLang);
	await storeRequests.updateLanguage(newLang);
	storeRequests.refreshProfile();
	storePrize.prizesLoaded = false;
};

onMounted(() => {
    storeScroll.header = nav.value;
})
</script>

<template>
	<nav class="app-nav" ref="nav" v-if="!isNotUserPage">
		<button v-for="tab in tabs" :key="tab.name" class="app-nav__item" :class="{ 'app-nav__item--active': route.name === tab.name }" @click="router.push({ name: tab.name })">
			<svg class="app-nav__icon" width='32' height='32'><use :href='tab.icon'></use></svg>
			<span class="app-nav__label">{{ t.nav[tab.name] }}</span>
		</button>
		<button class="app-nav__item app-nav__lang-toggle" :class="{ 'app-nav__item--active': false }" @click="toggleLang">
			<!-- <svg class="app-nav__icon" width="24" height="18"><use :href='`#${lang}`'></use></svg> -->
			 <img class='' width='24' height='24' src='@/assets/img/icons/world.png' alt='изображение'>
			<span class="app-nav__label">{{ lang.toUpperCase() }}</span>
		</button>
	</nav>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.app-nav {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(9, 20, 92, 1);
	border-top: 1px solid var(--border-accent-1-3);
	display: grid;
	grid-template-columns: repeat(4, 1fr) 1fr;
	z-index: 9999;
}

.app-nav__item {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.6rem;
	padding: 2rem 0rem 1rem;
	color: var(--system-fill-light);
	transition: color 0.2s;
}
.app-nav__lang-toggle {
	padding-right: 1.1rem;
    gap: 1.3rem;
	justify-content: space-between;
	img {
		width: 2.4rem;
		height: 2.4rem;
	}
}
.app-nav__item--active {
	color: var(--text-accent-1-100);
}

.app-nav__icon {
	width: 3.2rem;
	height: 3.2rem;
}

.app-nav__label {
	font-weight: 900;
	font-size: 1.3rem;
	text-transform: uppercase;
	text-align: center;
	@media (max-width: vars.$x360) {
		font-size: 1rem;
	}
}
</style>
